import styled from 'styled-components';
import { Form, Table } from 'antd';

const TABLE_HEADER_COLOR = '#2F54EB';

export const StepContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2.5rem;
	width: 100%;
`;

export const Header = styled.div`
	display: flex;
	align-items: flex-start;
	gap: 2.5rem;
`;

export const HeaderTexts = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	min-width: 0;
`;

export const Title = styled.h2`
	margin: 0;
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: ${({ theme }) => theme.sizes.fonts.fs_2xl};
	font-weight: ${({ theme }) => theme.sizes.weights.semibold};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_lg};
	letter-spacing: ${({ theme }) => theme.sizes.letter_spacings.ls_md};
`;

export const Subtitle = styled.p`
	margin: 0;
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: ${({ theme }) => theme.sizes.fonts.fs_md};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_md};
`;

export const HeaderDate = styled.span`
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: ${({ theme }) => theme.sizes.fonts.fs_md};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_md};
	white-space: nowrap;
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
`;

export const TableFormItem = styled(Form.Item)`
	margin: 0;
`;

export const FilesTable: typeof Table = styled(Table)`
	.ant-table {
		background: ${({ theme }) => theme.palette.secondary.white};
	}

	.ant-table-container {
		overflow: hidden;
		border-radius: ${({ theme }) => theme.border.border_radius.br_lg};
	}

	.ant-table-thead > tr > th {
		height: 3.5rem;
		padding: 0.5rem;
		background: ${TABLE_HEADER_COLOR};
		border-bottom: none;
		color: ${({ theme }) => theme.palette.secondary.white};
		font-size: ${({ theme }) => theme.sizes.fonts.fs_sm};
		font-weight: ${({ theme }) => theme.sizes.weights.semibold};
		line-height: ${({ theme }) => theme.sizes.line_heights.lh_md};
		text-align: center;
	}

	&& .ant-table-thead > tr > th.ant-table-cell:not(:last-child)::before {
		height: 100%;
		background-color: ${({ theme }) => theme.palette.secondary[200]};
	}

	.ant-table-tbody > tr > td {
		height: 3rem;
		padding: 1rem;
		border-bottom: 2px solid ${({ theme }) => theme.palette.secondary[100]};
		color: ${({ theme }) => theme.palette.secondary[400]};
		font-size: ${({ theme }) => theme.sizes.fonts.fs_xs};
		line-height: ${({ theme }) => theme.sizes.line_heights.lh_xs};
		letter-spacing: ${({ theme }) => theme.sizes.letter_spacings.ls_md};
		text-align: center;
	}

	.ant-table-tbody > tr:last-child > td {
		border-bottom: none;
	}

	.ant-table-selection-col {
		width: 4.5rem;
	}

	.ant-radio-inner {
		width: 1.25rem;
		height: 1.25rem;
	}

	.ant-table-pagination.ant-pagination {
		display: flex;
		align-items: center;
		gap: 0.25rem;
		margin: 1rem 0 0;
	}

	.ant-pagination-total-text {
		flex: 1;
		height: auto;
		margin: 0;
		color: ${({ theme }) => theme.palette.secondary[400]};
		font-size: ${({ theme }) => theme.sizes.fonts.fs_xs};
		line-height: ${({ theme }) => theme.sizes.line_heights.lh_xs};
		letter-spacing: ${({ theme }) => theme.sizes.letter_spacings.ls_md};
	}

	.ant-pagination-item,
	.ant-pagination-prev,
	.ant-pagination-next {
		min-width: 2rem;
		height: 2rem;
		margin: 0;
		line-height: 2rem;
	}

	.ant-pagination-item {
		border: none;
		border-radius: ${({ theme }) => theme.border.border_radius.br_sm};
		background: ${({ theme }) => theme.palette.secondary[100]};

		a {
			color: ${({ theme }) => theme.palette.secondary[250]};
			font-size: ${({ theme }) => theme.sizes.fonts.fs_xs};
			font-weight: ${({ theme }) => theme.sizes.weights.semibold};
		}
	}

	.ant-pagination-item-active {
		background: ${({ theme }) => theme.palette.primary[100]};

		a {
			color: ${({ theme }) => theme.palette.primary.default};
		}
	}

	.ant-pagination-item-link {
		border: none;
		background: transparent;
	}
`;
